
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Danh Sách Dịch Vụ Không Cố Định </h4>
      </div>
      <div class="modal-body">
        <div class="table-responsive" style="max-height: 400px;">
          <table class="table no-margin">
            <thead>
              <tr>
                <th><input type="checkbox" v-model="selectAll"></th>
                <th>Tên Dịch Vụ</th>
                <th>Phí</th>
                <th>Thuế</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in services" :key="index">
                <td><input type="checkbox" v-model="item.isChecked"></td>
                <td><a @click="onAdd(item)">{{item.name}}</a></td>
                <td><span class="label label-success">{{item.price}}</span></td>
                <td><span class="label label-primary">{{item.vat}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="onSave()"
        >{{$t('common.save')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
// import RegisterVehicleInputView from './RegisterVehicleInputView'
// import Confirm from "@/components/Confirm.vue"
// import moment from "moment"
//import LTECoreAlert from "@/components/LTESnackBar.vue"
// import utils from '@/lib/utils'

export default {
  name: "PackageOnceTimeServicesListView",
  props: {
    feeGroup: {
      type: Number,
      default() {
        return 2
      }
    },
    selectedServices: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      selectAll: false,
      services: []
    }
  },
  watch: {
    selectAll: function() {
      this.services.forEach(v => {
        v.isChecked = this.selectAll
      })
    },
    feeGroup: function() {
      this.getServicesByGroup(this.feeGroup)
    },
    selectedServices: function() {
      this.services.forEach(v => {
        let isExist = false
        for (let i=0;i<this.selectedServices.length;i++){
          let current = this.selectedServices[i]
          if (v.id == current.service) {
            isExist = true
            break;
          }
        }
        if (isExist){
          v.isChecked = true
        }
      })
    },
    services: function() {
      this.services.forEach(v => {
        let isExist = false
        for (let i=0;i<this.selectedServices.length;i++){
          let current = this.selectedServices[i]
          if (v.id == current.service) {
            isExist = true
            break;
          }
        }
        if (isExist){
          v.isChecked = true
        }
      })
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "GET_SERVICES_BY_GROUP"
    ]),
    onAdd: function(item) {
      item.isChecked = !item.isChecked
    },
    onSave: function() {
      let feegroup = this.feeGroup
      let selectedServices = []
      this.services.forEach(v => {
        if (v.isChecked) {
          selectedServices.push(v)
        }
      })
      this.$emit("package-services-save", feegroup, selectedServices)
    },
    getServicesByGroup: function(feegroup) {
      const data = {
        params: {
          feegroup: feegroup
        }
      }
      this.GET_SERVICES_BY_GROUP(data).then(
        function(res){
          let data = res.data
          let services = []
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              price: v.service_fee[0].fee_value ? v.service_fee[0].fee_value : 0,
              vat: v.vat ? v.vat : 0,
              feegroup: v.feegroup,
              isChecked: false
            }
            services.push(item)
          })
          this.services = services
        }.bind(this)
      )
    }
  },
  mounted() {
    this.getServicesByGroup(this.feeGroup)
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Service/PackageOnceTimeServicesListView.vue